import React, { useState } from "react";
import {
  Modal,
  Button,
  Flex,
  Box,
  Text,
  TextInput,
  Select,
  createStyles,
} from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { addSkypointProjectTaskStatus } from "../../services/skypointProject";

const useStyles = createStyles((theme) => ({
  // Modal styles (exact same as your inline styles)
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  inner: {
    padding: "20px",
  },

  modal: {
    maxWidth: "600px",
    width: "100%",
  },

  header: {
    backgroundColor: "white",
    padding: "20px 24px",
    borderBottom: "none",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },

  body: {
    padding: 0,
    backgroundColor: "#f8f9fa",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
  },

  close: {
    color: "#868e96",
    "&:hover": {
      backgroundColor: "#f1f3f5",
    },
  },

  // Main content area
  mainContent: {
    padding: theme.spacing.xl,
    backgroundColor: "#f8f9fa",
  },

  // Form container
  formContainer: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },

  // Cancel button styles
  cancelButton: {
    backgroundColor: "#f1f3f5",
    color: "#000000",
    border: "none",
    fontFamily: "Inter",
    borderRadius: "10px",
    fontWeight: 600,
    height: "44px",
    "&:hover": {
      backgroundColor: "#e9ecef",
    },
  },

  // Create button styles
  createButton: {
    backgroundColor: "#FFA94D",
    borderRadius: "10px",
    color: "#000000",
    fontFamily: "Inter",
    fontWeight: 600,
    height: "44px",
    "&:hover": {
      backgroundColor: "#FF922B",
    },
  },
}));

const TaskAddStatusModalSkypoint = ({ opened, onClose }) => {
  const { classes } = useStyles();
  const [statusValue, setStatusValue] = useState("");
  const [category, setCategory] = useState("active");

  // loading state for submit
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        status: statusValue,
        general: false,
        category,
      };

      const res = await addSkypointProjectTaskStatus(payload);
      res && handleCancel();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setStatusValue("");
    setCategory("active");
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleCancel}
      title={
        <Text size="lg" weight={700} style={{ fontFamily: "Inter" }}>
          Add Status
        </Text>
      }
      size="xl"
      centered
      zIndex={1000}
      padding={0}
      styles={{
        root: classes.root,
        inner: classes.inner,
        modal: classes.modal,
        header: classes.header,
        body: classes.body,
        close: classes.close,
      }}
      closeButtonProps={{
        icon: <IconX size={20} />,
      }}
    >
      <Box p="xl" className={classes.mainContent}>
        <Box className={classes.formContainer}>
          <Box mb="md">
            <TextInput
              placeholder="Enter status"
              value={statusValue}
              onChange={(e) => {
                setStatusValue(e.target.value);
              }}
            />
          </Box>

          <Box mb="md">
            <Select
              label="Category"
              placeholder="Select category"
              value={category}
              onChange={(value) => setCategory(value)}
              data={[
                { value: "active", label: "Active" },
                { value: "completed", label: "Completed" },
              ]}
            />
          </Box>

          <Flex gap="md" mt="xl" direction={{ base: "column", xs: "row" }}>
            <Button
              variant="default"
              fullWidth
              size="md"
              onClick={handleCancel}
              className={classes.cancelButton}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              size="md"
              onClick={handleSubmit}
              className={classes.createButton}
              loading={loading}
              disabled={loading || !statusValue?.trim()}
            >
              Save
            </Button>
          </Flex>
        </Box>
      </Box>
    </Modal>
  );
};

export default TaskAddStatusModalSkypoint;
